<template>
  <div class="d-flex justify-content-center" id="title-confimacao">Deseja realmente não realizar o adiantamento?</div>
</template>

<script>
import ModalConfimarSemAdiantamento from './ModalConfimarSemAdiantamento.js'
export default ModalConfimarSemAdiantamento
</script>

<style scoped>
#title-confimacao{
    font-size: 25px;
    font-weight: bold;
    color: #025e33;
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/ModalConfimarSemAdiantamento/ModalConfimarSemAdiantamento.vue